import api from "app/api";

export interface RegisterForm {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  account_name: string;
}

export async function register(item: RegisterForm) {
  return api.post(
    '/identity/register',
    {
      RegisterForm: item,
    },
    {
      public: true,
    }
  );
}

export async function registerActivation(token: string) {
  return api.post(
    `/identity/register-activation?token=${token}`,
    {},
    {
      public: true,
    }
  );
}